// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_teacher,
  add_teacher,
  update_teacher,
  delete_teacher,
  get_teacher_list,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const initialState = {
  teachers: [],
  teacherlist: [],
  teacherfilterlist: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    teacher_number: null,
    date_of_birth: "",
    gender: "",
    religion: "",
    blood_group: "",
    address: "",
    mobile_no: "",
    email: "",
    facebook: "",
    twitter: "",
    googleplus: "",
    linkedin: "",
    qualification: "",
    marital_status: "",
    file_name: "",
    department: "",
    designation: "",
    date_of_joining: null,
    joining_salary: null,
    date_of_leaving: null,
    account_holder_name: "",
    account_number: null,
    bank_name: "",
    ifsc_code: "",
    branch_name: "",
  },
};
// Async Thunks for API Calls
export const fetchteacherList = createAsyncThunk(
  "teacher/fetchteacherList",
  async ({school_id,department_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_teacher_list(school_id,department_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchfilterteacherList = createAsyncThunk(
  "teacher/fetchfilterteacherList",
  async ({school_id,department_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_teacher_list(school_id,department_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Async Thunks for API Calls
export const fetchTeacher = createAsyncThunk(
  "teacher/fetchTeacher",
  async ({ page, page_size,school_id, filter_fields,department_id,token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_teacher(page, page_size,school_id,filter_fields,department_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createTeacher = createAsyncThunk(
  "teacher/createTeacher",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_teacher(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateTeacher = createAsyncThunk(
  "teacher/updateTeacher",
  async ({ data, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await update_teacher(data, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTeacher = createAsyncThunk(
  "teacher/deleteTeacher",
  async ({ ids, token,school_id, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_teacher({ ids }, token,school_id, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const teacherSlice = createSlice({
  name: "teachers",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(reduxState, action) {
      reduxState.formData = { ...action.payload };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        teacher_number: 0,
        date_of_birth: "",
        gender: "",
        religion: "",
        blood_group: "",
        address: "",
        mobile_no: "",
        email: "",
        facebook: "",
        twitter: "",
        googleplus: "",
        linkedin: "",
        qualification: "",
        marital_status: "",
        file_name: "",
        department: "",
        designation: "",
        date_of_joining: "",
        joining_salary: 0,
        date_of_leaving: "",
        account_holder_name: "",
        account_number: 0,
        bank_name: "",
        ifsc_code: "",
        branch_name: "",
        username: "",
        password: "",
        image:""
      };
    },
    setTeacher(state, action) {
      state.teachers = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // User list
      .addCase(fetchteacherList.fulfilled, (state, action) => {
        state.teacherlist = action.payload.data;
      })
      .addCase(fetchteacherList.rejected, (state, action) => {
        state.teacherlist = [];

      })
      .addCase(fetchfilterteacherList.fulfilled, (state, action) => {
        state.teacherfilterlist = action.payload.data;
      })
      .addCase(fetchfilterteacherList.rejected, (state, action) => {
        state.teacherfilterlist = [];

      })
      // Fetch Classes
      .addCase(fetchTeacher.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTeacher.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchTeacher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTeacher.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createTeacher.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createTeacher.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateTeacher.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateTeacher.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateTeacher.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteTeacher.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTeacher.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteTeacher.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");

        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setTeacher,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize,
  setSchoolId,
} = teacherSlice.actions;
export default teacherSlice.reducer;
